import { useState } from "react";
import { toast } from "sonner";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api, errMsg } from "@/lib/api";

const FAQ = [
  ["Ali morajo gostje namestiti aplikacijo ali se registrirati?", "Ne. Gostje skenirajo QR kodo s kamero telefona, galerija se odpre v brskalniku. Vpišejo le ime in priimek, ki se prikaže ob njihovih fotografijah."],
  ["Kdo lahko vidi fotografije?", "Galerijo vidi vsak, ki ima QR kodo ali povezavo do vajine poroke. Povezave so nenapovedljive in poroke niso javno iskalne. Posamezne fotografije lahko kadarkoli skrijeta ali izbrišeta."],
  ["Ali se kakovost fotografij in videov zmanjša?", "Ne. Originalne datoteke shranimo v polni kakovosti. Za hitrejši prikaz galerije ustvarimo le manjše predogledne sličice."],
  ["Kako dolgo so spomini shranjeni?", "Vsak paket vključuje 365 dni hrambe. Če paket kupita pred poroko, hramba začne teči na dan poroke, sicer ob aktivaciji. Podaljšanje stane 19 € za vsako dodatno leto."],
  ["Koliko prostora imava na voljo?", "Privzeto 5 GB na poroko, kar je dovolj za več tisoč fotografij. Dodaten prostor je na voljo po dogovoru."],
  ["Kaj se zgodi po poteku hrambe?", "Datum izteka je vedno jasno prikazan v nadzorni plošči. Po izteku sledi 30-dnevno obdobje odloga, ko je galerija le na ogled in je prenos še mogoč, nato podatke trajno izbrišemo."],
  ["Kako prenesem vse fotografije?", "V nadzorni plošči kliknete »Prenesi vse (ZIP)«. Arhiv pripravimo v ozadju in prejmete varno začasno povezavo za prenos."],
];

export function Faq() {
  return (
    <section id="vprasanja" className="py-20 sm:py-28 bg-[#F3ECE1]/50 scroll-mt-16" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <p className="eyebrow">Pogosta vprašanja</p>
        <h2 className="font-display text-4xl sm:text-5xl font-light mt-3 mb-10">Vse, kar vaju zanima</h2>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQ.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="card-lux px-6 border" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display text-xl text-left hover:no-underline">{q}</AccordionTrigger>
              <AccordionContent className="text-[#6C6560] leading-relaxed">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}

export function Contact() {
  const [f, setF] = useState({ name: "", email: "", message: "", website: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/contact", { ...f, website: f.website || null });
      toast.success("Hvala! Odgovorili vam bomo v najkrajšem možnem času.");
      setF({ name: "", email: "", message: "", website: "" });
    } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
  };
  const inp = "w-full h-12 px-4 rounded-xl border border-[#DFD5C5] bg-white focus:outline-none focus:ring-2 focus:ring-[#C5A880]";
  return (
    <section id="kontakt" className="py-20 sm:py-28 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 scroll-mt-16" data-testid="contact-section">
      <div className="space-y-5">
        <p className="eyebrow">Kontakt</p>
        <h2 className="font-display text-4xl sm:text-5xl font-light">Imata vprašanje?</h2>
        <p className="text-[#6C6560] max-w-md">Pišita nam glede paketov, fizičnih izdelkov ali dodatnih storitev. Odgovorimo praviloma v enem delovnem dnevu.</p>
      </div>
      <form onSubmit={submit} className="card-lux p-6 sm:p-8 space-y-4">
        <input className={inp} placeholder="Ime in priimek" required minLength={2} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="contact-name-input" />
        <input className={inp} type="email" placeholder="E-poštni naslov" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="contact-email-input" />
        <textarea className={`${inp} h-auto py-3`} rows={5} placeholder="Sporočilo" required minLength={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="contact-message-input" />
        <input className="hidden" tabIndex={-1} autoComplete="off" value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} aria-hidden="true" />
        <button disabled={busy} className="btn-dark w-full h-12 disabled:opacity-50" data-testid="contact-submit-button">Pošlji sporočilo</button>
      </form>
    </section>
  );
}
